var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniOtrosResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ddp2z4zija",
    width: 18,
    height: 19,
    x: 11,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 11h18v17.177H11V11z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ddp2z4zija)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M25.197 28.177c-.094 0-.187-.022-.274-.068L20 25.52l-4.923 2.588c-.199.105-.44.088-.622-.045-.182-.132-.273-.356-.235-.577l.941-5.482-3.984-3.882c-.16-.156-.218-.391-.148-.605.07-.214.254-.37.477-.402l5.503-.8 2.461-4.987c.1-.201.305-.33.53-.33.224 0 .43.129.53.33l2.46 4.988 5.504.799c.223.033.407.188.476.402.071.214.012.449-.148.605l-3.983 3.882.94 5.482c.038.22-.053.445-.234.577-.104.075-.226.113-.348.113z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniOtrosResting);
export default __webpack_public_path__ + "static/media/icon_mini_otros_resting.cea759d46b49cb7b3cef45664dadaf0c.svg";
export { ForwardRef as ReactComponent };